import { Novedad } from '../models/novedades.models';

export const NOVEDADES_MOCK: Novedad[] = [
  {
    id: 'n-001',
    titulo: 'Nueva convocatoria de Capital Humano disponible',
    fecha: '2026-04-12',
    tipo: 'informacion',
    detalle: 'Ya se encuentra disponible la convocatoria para el concurso Capital Humano.',
    leida: false,
    roles: ['postulante', 'ayudante_postulante'],
  },
  {
    id: 'n-002',
    titulo: 'Se actualizan fechas de cierre de concursos 2026',
    fecha: '2026-04-10',
    tipo: 'completado',
    detalle: 'Se actualizaron los plazos de cierre para concursos vigentes del periodo 2026.',
    leida: true,
    roles: ['postulante', 'colaborador', 'representante_institucional', 'analista'],
  },
  {
    id: 'n-003',
    titulo: 'Publicada guia de revision para recomendadores',
    fecha: '2026-04-09',
    tipo: 'pendiente',
    detalle: 'Se habilito una guia para estandarizar la revision de recomendaciones.',
    leida: false,
    roles: ['recomendador', 'postulante'],
  },
  {
    id: 'n-004',
    titulo: 'Nuevo flujo de validacion para representante institucional',
    fecha: '2026-04-08',
    tipo: 'informacion',
    detalle: 'Se actualizo el flujo de validacion para mejorar el patrocinio institucional.',
    leida: true,
    roles: ['representante_institucional', 'ayudante_representante', 'postulante'],
  },
  {
    id: 'n-005',
    titulo: 'URC: se habilita panel de seguimiento de observaciones',
    fecha: '2026-04-07',
    tipo: 'completado',
    detalle: 'El panel de seguimiento de observaciones ya se encuentra habilitado para URC.',
    leida: false,
    roles: ['urc', 'postulante'],
  },
  {
    id: 'n-006',
    titulo: 'Analista: mejora en la vista de control de hitos',
    fecha: '2026-04-06',
    tipo: 'completado',
    detalle: 'Se implementaron mejoras visuales y de seguimiento para control de hitos.',
    leida: true,
    roles: ['analista', 'postulante'],
  },
  {
    id: 'n-007',
    titulo: 'Administrador ANID: actualizacion de permisos por rol',
    fecha: '2026-04-05',
    tipo: 'informacion',
    detalle: 'Se han actualizado los permisos de acceso para los diferentes roles de la plataforma.',
    leida: false,
    roles: ['administrador_anid', 'postulante'],
  },
  {
    id: 'n-008',
    titulo: 'Se publico documento de preguntas frecuentes',
    fecha: '2026-04-04',
    tipo: 'completado',
    detalle: 'Nuevo documento disponible con las preguntas mas frecuentes sobre postulaciones.',
    leida: true,
    roles: [
      'administrador_anid',
      'postulante',
      'ayudante_postulante',
      'colaborador',
      'representante_institucional',
      'ayudante_representante',
      'recomendador',
      'urc',
      'analista',
    ],
  },
  {
    id: 'n-009',
    titulo: 'Mantenimiento programado del sistema',
    fecha: '2026-04-09',
    tipo: 'pendiente',
    detalle: 'El sistema estara en mantenimiento el dia 10 de abril entre las 22:00 y 02:00 hrs.',
    leida: false,
    roles: ['postulante', 'ayudante_postulante', 'colaborador', 'representante_institucional', 'ayudante_representante'],
  },
];
